import { Filter } from "../filter";

export type UserStatusFilter = 'ALL' | 'ACTIVE' | 'BLOCKED';

export class UserFilter extends Filter {

    constructor(
        public status: UserStatusFilter = 'ALL',
        public permissions: string[] = [],
        /** NUC-79 Phase E: when true, the listing also includes soft-deleted users. */
        public includeDeleted: boolean = false,
        value: string = ""
    ) {
        super(value);
    }

    protected override onReset(): void {
        this.status = 'ALL';
        this.permissions = [];
        this.includeDeleted = false;
    }
}
